import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { acquisitionApiRequest } from "../../../utils/acquisition-api/AcquisitionApi";
import { checkIfInValidAcquisitionFlow, AcquisitionFlow } from "../../../utils/acquisition-utils";
import { DynamicResponse } from "../../../utils/api-utils/api-utils";

/**
 * 
 * @param props 
 * @param showPushdown 
 * @param validatingState 
 * @returns Empty string if no errors, otherwise returns the error string.
 */
export const stateZipCombinationValidation = async (
    showPushdown: Function,
    validatingState: TAcquisitionProviderFacade,
): Promise<string> => {
    if ( // Bypass StateZip Validation in the below flows.
        !checkIfInValidAcquisitionFlow(
            [
                AcquisitionFlow.PQ,
                AcquisitionFlow.PqOfOne,
                AcquisitionFlow.PHA,
                AcquisitionFlow.SkipPQCounter
            ]
        )
    ) {
        try {
            const { mailingState, mailingZip } = validatingState.getPersonalInfoForm();
            const response = await acquisitionApiRequest<boolean>(
                'validate-state-and-zip',
                { 
                    body: {
                        state: mailingState.value,
                        zipCode: mailingZip.value,
                    }
                    , method: 'POST' 
                },
                validatingState.getInitResponse(),
                )

            if (!response.data) {
                showPushdown('zipError');
                return 'Invalid State Zip Combination'
            }

        } catch (error: unknown) { // Failed to validate required State and Zip
            if (
                'response' in (error as {response?: DynamicResponse<boolean>})
                && [ 408, 500 ].includes((error as {response?: DynamicResponse<boolean>})?.response?.status)
            ) {
                const response = (error as {response: DynamicResponse<boolean>}).response ;
                if ([ 408, 500 ].includes(response?.status)) {
                    return 'Server Side Failure';
                }
            }
            return 'API Call Failure';
        }
    }
    return '';
}
